import { Component, EventEmitter, Input, Output, ChangeDetectorRef } from '@angular/core';
import { BRAND_LOGO_GREEN } from '../../../constants/constants-brand';

@Component({
  selector: 'upsell-modal',
  templateUrl: './upsell-modal.component.html',
  styleUrls: ['./upsell-modal.component.scss']
})
export class UpsellModalComponent {
  brandLogoGreen = BRAND_LOGO_GREEN;
  
  constructor(private cdr: ChangeDetectorRef) {}

  @Input() set upsellModalInputs(value: {
    title: string;
    message: string;
    buttonText: string;
    html: string;
  }) {
    this._upsellModalInputs = value;
    this.cdr.detectChanges();
  }
  get upsellModalInputs(): {
    title: string;
    message: string;
    buttonText: string;
    html: string;
  } {
    return this._upsellModalInputs;
  }
  private _upsellModalInputs: {
    title: string;
    message: string;
    buttonText: string;
    html: string;
  } = { title: '', message: '', buttonText: '', html: '' };

  @Input() set show(value: boolean) {
    this._show = value;
    this.cdr.detectChanges();
  }
  get show(): boolean {
    return this._show;
  }
  private _show: boolean = false;

  @Output() close = new EventEmitter<void>();
  @Output() cta = new EventEmitter<void>();

  onClose() {
    this.close.emit();
  }

  onCTA() {
    this.cta.emit();
  }

  onBackdropClick(event: Event) {
    // Only close if clicking the backdrop (not the modal content)
    if (event.target === event.currentTarget) {
      this.onClose();
    }
  }
} 